import React, { useState } from "react";

const FoodDetails = ({ formData, setFormData }) => {
  const [availability, setAvailability] = useState("Available");
  const [mealType, setMealType] = useState("Veg & Non Veg");
  const [weekdayMeals, setWeekdayMeals] = useState([]);
  const [weekendMeals, setWeekendMeals] = useState([]);
  const [chargesType, setChargesType] = useState("Fixed monthly amount");
  const [charges, setCharges] = useState("");
  const [perMealCharges, setPerMealCharges] = useState({
    Breakfast: "",
    Lunch: "",
    Dinner: "",
  });

  const toggleMeal = (meal, setMeals, meals) => {
    if (meals.includes(meal)) {
      setMeals(meals.filter((item) => item !== meal));
    } else {
      setMeals([...meals, meal]);
    }
  };

  const handlePerMealChange = (meal, value) => {
    setPerMealCharges({ ...perMealCharges, [meal]: value });
  };

  const updateFormData = () => {
    setFormData((prevState) => ({
      ...prevState,
      pricingAndOthers: {
        ...prevState.pricingAndOthers,
        foodDetails: {
          availability,
          mealType,
          weekdayMeals,
          weekendMeals,
          chargesType,
          charges,
          perMealCharges,
        },
      },
    }));
  };

  return (
    <div className="">
      <h2 className="text-xl font-semibold mb-6">Food details</h2>

      {/* Availability */}
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Availability
        </label>
        <div className="flex gap-4">
          {["Available", "Not Available"].map((option) => (
            <button
              type="button"
              key={option}
              onClick={() => {
                setAvailability(option);
                updateFormData();
              }}
              className={`px-2 text-sm py-1 border rounded-md ${availability === option
                  ? "bg-blue-100 border-blue-500 text-blue-600"
                  : "bg-white border-gray-300 text-gray-600"
                }`}
            >
              {option}
            </button>
          ))}
        </div>
      </div>

      {availability === "Available" && (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Meal Type */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Meal type (Optional)
              </label>
              <div className="flex gap-4">
                {["Only Veg", "Veg & Non Veg"].map((option) => (
                  <button
                    type="button"
                    key={option}
                    onClick={() => {
                      setMealType(option);
                      updateFormData();
                    }}
                    className={`px-2 text-sm py-1 border rounded-md ${mealType === option
                        ? "bg-blue-100 border-blue-500 text-blue-600"
                        : "bg-white border-gray-300 text-gray-600"
                      }`}
                  >
                    {option}
                  </button>
                ))}
              </div>
            </div>

            {/* Availability of Meals on Weekdays */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Availability of meal on weekdays (Optional)
              </label>
              <div className="flex gap-4">
                {["Breakfast", "Lunch", "Dinner"].map((meal) => (
                  <button
                    type="button"
                    key={meal}
                    onClick={() => {
                      toggleMeal(meal, setWeekdayMeals, weekdayMeals);
                      updateFormData();
                    }}
                    className={`px-2 text-sm py-1 border rounded-md ${weekdayMeals.includes(meal)
                        ? "bg-blue-100 border-blue-500 text-blue-600"
                        : "bg-white border-gray-300 text-gray-600"
                      }`}
                  >
                    {meal}
                  </button>
                ))}
              </div>
            </div>

            {/* Availability of Meals on Weekends */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Availability of meal on weekends (Optional)
              </label>
              <div className="flex gap-4">
                {["Breakfast", "Lunch", "Dinner"].map((meal) => (
                  <button
                    type="button"
                    key={meal}
                    onClick={() => {
                      toggleMeal(meal, setWeekendMeals, weekendMeals);
                      updateFormData();
                    }}
                    className={`px-2 text-sm py-1 border rounded-md ${weekendMeals.includes(meal)
                        ? "bg-blue-100 border-blue-500 text-blue-600"
                        : "bg-white border-gray-300 text-gray-600"
                      }`}
                  >
                    {meal}
                  </button>
                ))}
              </div>
            </div>

            {/* Charges for Food */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Charges for Food (Optional)
              </label>
              <div className="flex gap-2 mb-4">
                {["Included in rent", "Per meal basis", "Fixed monthly amount"].map(
                  (option) => (
                    <button
                      type="button"
                      key={option}
                      onClick={() => {
                        setChargesType(option);
                        updateFormData();
                      }}
                      className={`px-2 text-sm py-1 whitespace-nowrap border rounded-md ${chargesType === option
                          ? "bg-blue-100 border-blue-500 text-blue-600"
                          : "bg-white border-gray-300 text-gray-600"
                        }`}
                    >
                      {option}
                    </button>
                  )
                )}
              </div>

              {chargesType === "Fixed monthly amount" && (
                <input
                  type="text"
                  value={charges}
                  onChange={(e) => {
                    setCharges(e.target.value);
                    updateFormData();
                  }}
                  placeholder="Enter food charges"
                  className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                />
              )}

              {chargesType === "Per meal basis" && (
                <div className="flex flex-col gap-3">
                  {["Breakfast", "Lunch", "Dinner"].map((meal) => (
                    <div key={meal} className="flex flex-col gap-2">
                      <label className="text-sm font-medium text-gray-700">
                        {meal}
                      </label>
                      <input
                        type="text"
                        value={perMealCharges[meal]}
                        onChange={(e) => {
                          handlePerMealChange(meal, e.target.value);
                          updateFormData();
                        }}
                        placeholder={`Enter ${meal.toLowerCase()} charges`}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default FoodDetails;
